import axios from "../plugins/parseAxios";
import {MeterRecordAPI  } from "../api"
export class MeterRecord {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getMeterRecordsByMarket(marketId, month, year) {
    const { data } = await MeterRecordAPI.getMeterRecordsByMarket(
      marketId,
      month,
      year,
    );
    return data.result.filter(d => d).map((item) => (item = new MeterRecord(item)));
  }
  static async saveMeterRecords(marketId, month, year, formData) {
    const { data } = await MeterRecordAPI.saveMeterRecords(
      marketId,
      month,
      year,
      formData,
    );
    return data.result.filter(d => d).map((item) => (item = new MeterRecord(item)));
  }
  static async getLastMeterRecordsByMeters(meterIds) {
    const { data } = await MeterRecordAPI.getLastMeterRecordsByMeters(
      meterIds
    );
    return data.result.filter(d => d).map((item) => (item = new MeterRecord(item)));
  }
}
